export const parseToFixed = (value, fixed) => {
  let parseNumber = parseFloat(value);
  return +parseNumber.toFixed(fixed);
};

export const thousandSeparator = value => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
